import React from 'react'
import { NavLink } from 'react-router-dom'
import cx from 'classnames'
import { Icon, Icons } from '../icon'

type IconType = (typeof Icons)[keyof typeof Icons]

export interface NavigationItemProps {
  icon: IconType
  title: string
  description: string
  to: string
  end?: boolean
}

export const NavigationItem = ({
  icon,
  title,
  description,
  to,
  end = false,
}: NavigationItemProps) => {
  return (
    <li>
      <NavLink
        className={({ isActive }) =>
          cx('navigation-menu-link', { 'is-active': isActive })
        }
        to={to}
        end={end}
        aria-current="page"
      >
        <span className="navigation-menu-title">
          <Icon name={icon} size={14} /> {title}
        </span>
        <span className="navigation-menu-description">{description}</span>
      </NavLink>
    </li>
  )
}

const NavigationMenu = ({ children }: { children: React.ReactNode }) => {
  return <ul className="navigation-menu">{children}</ul>
}

export default NavigationMenu
